import { TextButton } from '../../index'

const ResetAllToDefaultButton = ({onClick, className}) => {
  return (
    <TextButton clickHandler={onClick} className={className} secondaryButton>Reset all to Default</TextButton>
  )
}

export default ResetAllToDefaultButton
